import BasicDetails from '../../Programmatic/BasicDetails';

const ContextualBasicDetails = () => {
  return <BasicDetails />;
};

export default ContextualBasicDetails;
